module.exports = __webpack_public_path__ + "static/media/sgd-11.72f7db27.png";